import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { RtiDescriptionField, RTI_TEXT_MAX_LENGTH, parseOdsTextareaValue } from './rti-description-field';

const FOOTER_TEXTAREA_ID = 'rti-report-footer-description';

export type RtiReportFooterProps = {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
};

export const RtiReportFooter = ({ value, onChange, disabled = false }: RtiReportFooterProps) => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (nextValue: unknown) => {
      const next = parseOdsTextareaValue(nextValue);
      onChange(next.slice(0, RTI_TEXT_MAX_LENGTH));
    },
    [onChange],
  );

  const handleBlur = useCallback(() => {
    onChange(value.trim());
  }, [onChange, value]);

  return (
    <section className='flex flex-col gap-4' aria-labelledby='rti-report-footer-title'>
      <h3
        id='rti-report-footer-title'
        className='font-ods-font-family-secondary text-ods-font-styles-body-regular-small font-bold text-[#1D1D1D]'
      >
        {t('pe.settings.rti.footer.title')}
      </h3>
      <p className='font-ods-font-family-secondary text-ods-font-styles-body-regular-small font-normal text-[#1D1D1D] -mt-2'>
        {t('pe.settings.rti.footer.helper')}
      </p>
      <RtiDescriptionField
        id={FOOTER_TEXTAREA_ID}
        label={t('pe.settings.rti.footer.fieldLabel')}
        placeholder={t('pe.settings.rti.header.footer.placeholder')}
        value={value}
        onChange={handleChange}
        onBlur={handleBlur}
        disabled={disabled}
      />
    </section>
  );
};
